import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ethnicWear from './images/ethnic.jpg';
import westernWear from './images/western.jpg';
import formalWear from './images/short.jpg';
import coordSets from './images/dress2.jpg';

const CATEGORY_TO_SLUG = {
  'Western Wear': 'western-wear',
  'Ethnic Wear': 'ethnic-wear',
  'Formal Wear': 'formal-wear',
  'Co-ord Sets': 'co-ord-sets',
};

export default function PlusSizes() {
  const navigate = useNavigate();
  const [tryBag] = useState(() => {
    try {
      const saved = localStorage.getItem('fivetryBag');
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  });

  const categories = [
    { name: 'Western Wear', image: westernWear },
    { name: 'Ethnic Wear', image: ethnicWear },
    { name: 'Formal Wear', image: formalWear },
    { name: 'Co-ord Sets', image: coordSets },
  ];

  const isMobile = window.innerWidth < 600;

  const openCategory = (name) => navigate('/shop/' + CATEGORY_TO_SLUG[name] + '?plus=1');

  return (
    <div style={{ minHeight: '100vh', fontFamily: 'Arial', background: '#fafaf7', paddingBottom: '90px' }}>

      {/* NAVBAR */}
      <div style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fafaf7', borderBottom: '0.5px solid #eeeae3', display: 'flex', alignItems: 'center', padding: '18px 24px' }}>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
          <span onClick={() => navigate('/')} style={{ cursor: 'pointer', fontSize: '20px', color: '#1a1a1a', padding: '4px 8px' }}>←</span>
        </div>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          <h1 onClick={() => navigate('/')} style={{ margin: 0, fontSize: '22px', fontWeight: '500', color: '#1a1a1a', fontFamily: '"Playfair Display", Georgia, serif', letterSpacing: '6px', paddingLeft: '6px', cursor: 'pointer' }}>FIVETRY</h1>
        </div>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
          <span onClick={() => navigate('/?openTrybag=true')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', position: 'relative', gap: '6px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1.15' }}>
              <span style={{ fontSize: '11px', fontWeight: '600', letterSpacing: '2px', color: '#1a1a1a' }}>TRY</span>
              <span style={{ fontSize: '11px', fontWeight: '600', letterSpacing: '2px', color: '#1a1a1a' }}>BAG</span>
            </div>
            <span style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 2 L3 6 V20 a2 2 0 0 0 2 2 H19 a2 2 0 0 0 2-2 V6 L18 2 Z" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <path d="M16 10 a4 4 0 0 1 -8 0" />
              </svg>
              {tryBag.length > 0 && (
                <span style={{ position: 'absolute', top: '-7px', right: '-9px', background: '#1a1a1a', color: 'white', borderRadius: '50%', width: '16px', height: '16px', fontSize: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600' }}>{tryBag.length}</span>
              )}
            </span>
          </span>
        </div>
      </div>

      {/* PLUS SIZES HEADER BAND */}
      <div style={{ background: '#1a1a1a', padding: '34px 24px', textAlign: 'center' }}>
        <div style={{ fontFamily: 'neto serif', fontSize: '22px', color: '#b89968', marginBottom: '6px', fontWeight: '500', fontStyle: 'italic', letterSpacing: '0.3px' }}>Specially for you</div>
        <div style={{ fontFamily: 'neto serif', fontSize: '24px', color: '#ffffff', fontWeight: '500', marginBottom: '8px', letterSpacing: '0.5px', lineHeight: '1.1' }}>4xl - 5xl - 6xl</div>
        <div style={{ fontSize: '12px', color: '#a8a092', fontStyle: 'italic', letterSpacing: '0.2px' }}>Premium styles in every size. Always.</div>
      </div>

      {/* SECTION EYEBROW */}
      <div style={{ padding: '50px 24px 20px', textAlign: 'center' }}>
        <div style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '13px', letterSpacing: '5px', color: '#9c7d4f', fontWeight: '600', textTransform: 'uppercase' }}>Shop by category</div>
      </div>

      {/* CATEGORY TILES */}
      <div style={{ padding: '0 18px 50px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: window.innerWidth < 1200 ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: isMobile ? '14px' : '22px', maxWidth: '1200px', margin: '0 auto' }}>
          {categories.map((cat) => (
            <div key={cat.name} onClick={() => openCategory(cat.name)} style={{ cursor: 'pointer', position: 'relative', overflow: 'hidden', borderRadius: '16px', height: isMobile ? '280px' : '420px', background: '#eeeae3' }}>
              <img src={cat.image} alt={cat.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <div style={{ position: 'absolute', bottom: '18px', left: '50%', transform: 'translateX(-50%)', background: '#9c7d4f', color: 'white', padding: isMobile ? '8px 14px' : '10px 20px', borderRadius: '6px', fontSize: isMobile ? '11px' : '13px', fontWeight: '500', whiteSpace: 'nowrap', fontFamily: '"Playfair Display", Georgia, serif', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>Shop {cat.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}